import { render } from "./trader-drawdown.vue?vue&type=template&id=0f8fede0"
import script from "./trader-drawdown.vue?vue&type=script&lang=js"
export * from "./trader-drawdown.vue?vue&type=script&lang=js"

import "./trader-drawdown.vue?vue&type=style&index=0&id=0f8fede0&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__